import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import "./styles.css";
import {instanceMob} from "../../../../utils/utils";
import InlineModal from "../../../info-modal/infoModal";
import {useModalManager} from "./useModalManager";
import Tooltip from "../../../tooltip/tooltip";
import Popover from "../../../popover/popover";
import DisclaimerModal from "../../../disclaimer-modal/disclaimer-modal";

export const disclaimers = {
    renew: {
        title: "¿Qué significa renovar un plan?",
        description:
            "Al renovar el plan de un usuario, estarás activando un nuevo periodo de uso con la cantidad de clases seleccionadas. Puedes definir desde qué fecha inicia el nuevo plan y, si lo deseas, sumar los accesos no utilizados del plan anterior marcando la opción correspondiente. Recuerda: Esta acción extiende el tiempo y número de accesos disponibles para el usuario.",
        storageKey: "disclaimerRenew",
    },
    edit: {
        title: "¿Qué significa modificar plan?",
        description:
            "Edita la información actual del plan activo de este cliente. Puedes cambiar el plan de tu cliente, selecciona el nuevo método de pago, puedes congelar temporalmente la membresía o añadir servicios adicionales según sea necesario.",
        storageKey: "disclaimerEdit",
    },
    assign: {
        title: "¿Qué significa asignar un plan?",
        description:
            "En este modal podrás seleccionar la sede donde estará activo el plan, elegir al usuario sin plan, definir cuál será el plan que adquirirá y establecer la fecha de inicio. También podrás indicar la fecha de pago, aplicar un porcentaje de descuento si corresponde, verificar el valor total y registrar el método de pago. Este proceso asegura que la membresía del cliente quede activada con toda la información y condiciones necesarias para su correcto seguimiento.",
        storageKey: "disclaimerAssign",
    },
    add: {
        title: "¿Qué significa agregar plan?",
        description:
            "Completa la información para crear un nuevo plan para tu cliente. Indica el nombre del plan, define el ciclo y la frecuencia de renovación, asigna el número de congelaciones y el costo en pesos colombianos. Si marcas Accesos libres, tu cliente podrá usar sus accesos cuando y como lo desee.\n\nEn la sección de Servicios, selecciona el tipo de servicio, el número de accesos o márcalo como ilimitado. Puedes agregar varios servicios usando el botón Agregar más servicios.",
        storageKey: "disclaimerAdd",
    },
};

const PlanFormModal = ({show, onClose, mode, data = null, onSuccess}) => {
    const [services, setServices] = useState([]);
    const [listServices, setListServices] = useState();
    const [locations, setLocations] = useState([]);
    const [plans, setPlans] = useState([]);
    const [usersNoPlan, setUsersNoPlan] = useState(null);
    const [planDetail, setPlanDetail] = useState(null);
    const [formValues, setFormValues] = useState({
        plan: "",
        location: "",
        payment: "",
    });
    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);

    const getTitleByMode = (mode, data) => {
        if (mode === "add" && data && Number.isInteger(Number(data))) {
            return {first: "Editar", rest: "Plan"};
        }

        const titles = {
            renew: "Renovar Plan",
            edit: "Modificar Plan",
            assign: "Asignar Plan",
            add: "Agregar Plan",
        };

        const title = titles[mode] || "Plan";
        const [first, ...restParts] = title.split(" ");
        return {first, rest: restParts.join(" ")};
    };

    const {activeModal, modalData, openModal, closeModal} = useModalManager();
    const {first: titleAction, rest: titleSubject} = getTitleByMode(mode, data);

    const getLocations = () => {
        return instanceMob
            .get(`admin/location/list`)
            .then((res) => res.data)
            .then((data) => setLocations(data))
            .catch((err) => console.error(err));
    };

    const getPlans = () => {
        return instanceMob
            .get(`admin/plan?no_paginate=True`)
            .then((res) => res.data)
            .then((data) => setPlans(data))
            .catch((err) => console.error(err));
    };

    const getListServices = () => {
        return instanceMob
            .get(`admin/service`)
            .then((res) => res.data)
            .then((data) => {
                setListServices(data);
                return data;
            })
            .catch((err) => console.error(err));
    };

    const getPlanDetail = (id) => {
        return instanceMob
            .get(`admin/plan/${id}`)
            .then((res) => res.data)
            .then((data) => {
                setPlanDetail(data);
                return data;
            })
            .catch((err) => console.error(err));
    };

    const getUsersNoPlan = () => {
        return instanceMob
            .get('admin/customer/noplan')
            .then((res) => res.data)
            .then((data) => {
                setUsersNoPlan(data?.results)
                return data?.results;
            })
            .catch((err) => console.error(err));
    };

    const addService = () =>
        setServices((prev) => [
            ...(prev || []),
            {service: "", accesses: "", unlimited: false},
        ]);

    const removeService = (index) =>
        setServices(services.filter((_, i) => i !== index));

    const updateService = (index, field, value) => {
        setServices((prev) => {
            const list = [...(prev || [])];
            const next = {...(list[index] || {})};
            if (field === "service") value = Number(value);
            if (field === "unlimited") value = Boolean(value);
            next[field] = value;
            if (field === "unlimited") {
                next.accesses = value ? "" : next.accesses;
            }
            list[index] = next;
            return list;
        });
    };

    const toDMY = (iso) => {
        if (!iso) return null;
        const [y, m, d] = iso.split("-");
        return `${d}-${m}-${y}`;
    };

    const toDecimal = (val) => {
        if (val === null || val === undefined || val === "") return null;
        const num = Number(val);
        if (isNaN(num)) return null;
        return num;
    };

    const mapPlanServices = (planServices = []) =>
        planServices.map((s) => {
            const quotaNum = Number(s.quota);
            const isUnlimited = quotaNum === -1;
            return {
                service: s.service_id,
                name: s.service_name ?? "",
                accesses: isUnlimited ? "" : String(quotaNum),
                unlimited: isUnlimited,
            };
        });

    const handleSavePlan = () => {
        if (sending) return;
        setSending(true);

        const isValid = validateForm(formValues, openModal, closeModal, "add", services);
        if (!isValid) {
            setSending(false);
            return;
        }

        const isEdit = data && Number.isInteger(Number(data));

        const payload = {
            name: formValues.name,
            total_spots_per_service: formValues.unlimited_spots
                ? -1
                : Number(formValues.total_spots_per_service) || 0,
            renewal_cycle_time: Number(formValues.renewal_cycle_time),
            renewal_cycle_value: Number(formValues.renewal_cycle_value),
            full_services_access: Boolean(formValues.full_services_access),
            max_freeze_times: Number(formValues.max_freeze_times),
            description: formValues.description || "",
            price: formValues.price ? Number(formValues.price) : undefined,
            currency: formValues.currency || undefined,
            services: formValues.full_services_access
                ? []
                : services.map(s => ({
                    service: s.service,
                    quota: s.unlimited ? -1 : Number(s.accesses)
                }))
        };

        let url = `admin/plan/create`;
        let method = "post";

        if (isEdit) {
            url = `admin/plan/${data}/update`;
            method = "patch";
        }

        instanceMob[method](url, payload)
            .then((res) => res.data)
            .then(() => {
                openModal('InfoModal', `Plan ${isEdit ? "actualizado" : "creado"} correctamente`);
                if (onSuccess) onSuccess();
            })
            .catch((err) => {
                console.error("❌ Error:", err);
                const backendMsg = getBackendError(err);

                openModal("InfoModal", {
                    title: "Error",
                    description: backendMsg,
                    primaryAction: {
                        label: "Aceptar",
                        onClick: () => closeModal(),
                    },
                });
            })
            .finally(() => setSending(false));
    };

    const handleCancelRenew = (customer_id) => {
        if (!customer_id) return;
        instanceMob
            .post(`admin/membership/renew/${customer_id}/cancel`)
            .then(() => {
                openModal('InfoModal', 'Renovación cancelada correctamente');
                if (onSuccess) onSuccess();
            })
            .catch((err) => {
                console.error("❌ Error:", err);
                const backendMsg = getBackendError(err);

                openModal("InfoModal", {
                    title: "Error",
                    description: backendMsg,
                    primaryAction: {
                        label: "Aceptar",
                        onClick: () => closeModal(),
                    },
                });
            });
    };

    const handleEditMembership = () => {
        if (sending) return;
        setSending(true);

        const isValid = validateForm(formValues, openModal, closeModal, mode);
        if (!isValid) {
            setSending(false);
            return;
        }

        const mainMembership = data?.memberships?.[0];
        if (!mainMembership) {
            setSending(false);
            return;
        }

        const membershipId = mainMembership.membership_id;

        const originalExtra = (data?.memberships || []).filter(m => m.extra_membership);
        const extra_service = {};

        originalExtra.forEach(orig => {
            const inForm = services.find(s => Number(s.service) === Number(orig.membership_service_id));

            if (inForm) {
                extra_service[orig.membership_service_id] = {
                    quota: inForm.unlimited ? -1 : Number(inForm.accesses) || 0,
                    id_membership: orig.membership_id,
                    delete: false,
                };
            } else {
                extra_service[orig.membership_service_id] = {
                    quota: orig.remaining_quota === -1 ? -1 : Number(orig.remaining_quota) || 0,
                    id_membership: orig.membership_id,
                    delete: true,
                };
            }
        });

        services.forEach(s => {
            const existed = originalExtra.some(o => Number(o.membership_service_id) === Number(s.service));
            if (!existed) {
                extra_service[s.service] = {
                    quota: s.unlimited ? -1 : Number(s.accesses) || 0,
                    id_membership: null,
                    delete: false,
                };
            }
        });

        const payload = {
            location: Number(formValues.location) || null,
            frozen: !!formValues.freeze,
            plan_id: Number(formValues.plan) || null,
            payment_method: Number(formValues.payment) || null,
            extra_service,
            other_payment_method: Number(formValues.other_payment) || null,
            payment_date: toDMY(formValues.customer_payment_date || null),
            plan_value: toDecimal(formValues.customer_plan_value),
            plan_discount: Number(formValues.customer_plan_discount),
            plan_total_value: toDecimal(formValues.customer_plan_total_value) || null,
        };

        if (formValues.freeze) {
            payload.freeze_start_date = toDMY(formValues.membership_freeze_start_date);
            payload.freeze_end_date = toDMY(formValues.membership_freeze_end_date);
        }

        instanceMob.patch(`admin/membership/${membershipId}/update`, payload)
            .then(res => res.data)
            .then(() => {
                openModal("InfoModal", "Membresía actualizada correctamente");
                if (onSuccess) onSuccess();
            })
            .catch((err) => {
                console.error("❌ Error:", err);
                const backendMsg = getBackendError(err);

                openModal("InfoModal", {
                    title: "Error",
                    description: backendMsg,
                    primaryAction: {
                        label: "Aceptar",
                        onClick: () => closeModal(),
                    },
                });
            })
            .finally(() => setSending(false));
    };

    const handleRenewMembership = () => {
        if (sending) return;
        setSending(true);

        const isValid = validateForm(formValues, openModal, closeModal, mode);
        if (!isValid) {
            setSending(false);
            return;
        }

        const payload = {
            customer: Number(data?.customer_id),
            date: toDMY(formValues.new_plan_start_date),
            old_services: formValues.carry_over ? (formValues.old_services || []) : [],
            new_plan: Number(formValues.plan),
            payment_method: Number(formValues.payment),
            location: Number(formValues.location),
            payment_date: toDMY(formValues.customer_payment_date || null),
            plan_value: toDecimal(formValues.customer_plan_value),
            plan_discount: toDecimal(formValues.customer_plan_discount),
            plan_total_value: toDecimal(formValues.customer_plan_total_value),
            other_payment_method: formValues.other_payment || "",
        };

        instanceMob
            .post("admin/membership/plan/renew", payload)
            .then((res) => res.data)
            .then(() => {
                openModal("InfoModal", "Plan renovado correctamente");
                if (onSuccess) onSuccess();
            })
            .catch((err) => {
                console.error("❌ Error:", err);
                const backendMsg = getBackendError(err);

                openModal("InfoModal", {
                    title: "Error",
                    description: backendMsg,
                    primaryAction: {
                        label: "Aceptar",
                        onClick: () => closeModal(),
                    },
                });
            })
            .finally(() => setSending(false));
    };

    const handleAssignMembership = () => {
        if (sending) return;
        setSending(true);

        const isValid = validateForm(formValues, openModal, closeModal, mode);
        if (!isValid) {
            setSending(false);
            return;
        }

        const payload = {
            plan: Number(formValues.plan),
            customer: Number(formValues.customer),
            date: toDMY(formValues.start_date),
            payment_method: Number(formValues.payment),
            location: Number(formValues.location),
            payment_date: toDMY(formValues.customer_payment_date),
            plan_value: toDecimal(formValues.customer_plan_value),
            plan_discount: toDecimal(formValues.customer_plan_discount),
            plan_total_value: toDecimal(formValues.customer_plan_total_value),
            other_payment_method: formValues.other_payment || ""
        };

        instanceMob.post("admin/membership/plan/create", payload)
            .then(res => res.data)
            .then(() => {
                openModal("InfoModal", "Plan asignado correctamente");
                if (onSuccess) onSuccess();
            })
            .catch((err) => {
                console.error("❌ Error:", err);
                const backendMsg = getBackendError(err);

                openModal("InfoModal", {
                    title: "Error",
                    description: backendMsg,
                    primaryAction: {
                        label: "Aceptar",
                        onClick: () => closeModal(),
                    },
                });
            })
            .finally(() => setSending(false));
    };

    const validateForm = (formValues, openModal, closeModal, mode, services = []) => {
        if (mode === "add") {
            if (!formValues.name?.trim()) {
                openModal("InfoModal", {
                    title: "Error de validación",
                    description: "Debes ingresar un nombre para el plan.",
                    primaryAction: {label: "Aceptar", onClick: () => closeModal()}
                });
                return false;
            }

            if (!formValues.renewal_cycle_time) {
                openModal("InfoModal", {
                    title: "Error de validación",
                    description: "Debes seleccionar un ciclo de renovación.",
                    primaryAction: {label: "Aceptar", onClick: () => closeModal()}
                });
                return false;
            }

            if (!formValues.renewal_cycle_value || Number(formValues.renewal_cycle_value) <= 0) {
                openModal("InfoModal", {
                    title: "Error de validación",
                    description: "Debes ingresar una frecuencia de renovación válida.",
                    primaryAction: {label: "Aceptar", onClick: () => closeModal()}
                });
                return false;
            }

            if (!formValues.price || Number(formValues.price) <= 0) {
                openModal("InfoModal", {
                    title: "Error de validación",
                    description: "Debes ingresar un precio válido para el plan.",
                    primaryAction: {label: "Aceptar", onClick: () => closeModal()}
                });
                return false;
            }

            if (formValues.full_services_access) {
                if (
                    !formValues.unlimited_spots &&
                    (!formValues.total_spots_per_service || Number(formValues.total_spots_per_service) <= 0)
                ) {
                    openModal("InfoModal", {
                        title: "Error de validación",
                        description: "Debes indicar una cantidad de accesos libres o marcar como ilimitados.",
                        primaryAction: {label: "Aceptar", onClick: () => closeModal()}
                    });
                    return false;
                }
            } else {
                if (!services.length) {
                    openModal("InfoModal", {
                        title: "Error de validación",
                        description: "Debes agregar al menos un servicio.",
                        primaryAction: {label: "Aceptar", onClick: () => closeModal()}
                    });
                    return false;
                }

                for (const s of services) {
                    if (!s.service) {
                        openModal("InfoModal", {
                            title: "Error de validación",
                            description: "Cada servicio debe tener un tipo seleccionado.",
                            primaryAction: {label: "Aceptar", onClick: () => closeModal()}
                        });
                        return false;
                    }
                    if (!s.unlimited && (!s.accesses || Number(s.accesses) <= 0)) {
                        openModal("InfoModal", {
                            title: "Error de validación",
                            description: "Cada servicio debe tener un número de accesos válido o estar marcado como ilimitado.",
                            primaryAction: {label: "Aceptar", onClick: () => closeModal()}
                        });
                        return false;
                    }
                }
            }
            return true;
        }

        const planChanged = mode === "edit" && formValues.plan !== formValues.initial_plan;

        if ((mode !== "edit" || planChanged) && (!formValues.location || formValues.location === "-1")) {
            openModal("InfoModal", {
                title: "Error de validación",
                description: "Debes seleccionar una locación.",
                primaryAction: {label: "Aceptar", onClick: () => closeModal()}
            });
            return false;
        }

        if (!formValues.plan || formValues.plan === "-1") {
            openModal("InfoModal", {
                title: "Error de validación",
                description: "Debes seleccionar un plan.",
                primaryAction: {label: "Aceptar", onClick: () => closeModal()}
            });
            return false;
        }

        const extraServicesChanged =
            mode === "edit" &&
            JSON.stringify(services) !== JSON.stringify(formValues.initial_extra_services || []);

        const shouldValidatePayment =
            mode !== "edit" ||
            (
                mode === "edit" &&
                planChanged &&
                !formValues.freeze &&
                !formValues.initial_freeze &&
                !extraServicesChanged
            );

        if (formValues.plan && shouldValidatePayment) {
            if (
                !formValues.payment ||
                !formValues.customer_payment_date ||
                !formValues.customer_plan_value ||
                !formValues.customer_plan_total_value ||
                (Number(formValues.payment) === 50 && !formValues.other_payment?.trim())
            ) {
                openModal("InfoModal", {
                    title: "Error de validación",
                    description: "Si seleccionas un plan, debes completar todos los datos de pago.",
                    primaryAction: {label: "Aceptar", onClick: () => closeModal()}
                });
                return false;
            }
        }

        if (mode === "assign") {
            if (!formValues.customer) {
                openModal("InfoModal", {
                    title: "Error de validación",
                    description: "Debes seleccionar un usuario.",
                    primaryAction: {label: "Aceptar", onClick: () => closeModal()}
                });
                return false;
            }

            if (!formValues.start_date) {
                openModal("InfoModal", {
                    title: "Error de validación",
                    description: "Debes seleccionar una fecha de inicio.",
                    primaryAction: {label: "Aceptar", onClick: () => closeModal()}
                });
                return false;
            }
        }

        return true;
    };

    const getBackendError = (err) => {
        let rawError =
            err?.response?.data?.[0] ||
            err?.response?.data?.error ||
            err?.response?.data?.message ||
            err?.message ||
            "Ocurrió un error inesperado";

        if (Array.isArray(rawError)) {
            return rawError.join(" ");
        }

        if (typeof rawError === "string" && rawError.startsWith("['")) {
            try {
                const parsed = JSON.parse(
                    rawError.replace(/'/g, '"')
                );
                if (Array.isArray(parsed)) return parsed.join(" ");
                return parsed;
            } catch {
                return rawError.replace(/[\\[\]']/g, "");
            }
        }

        return rawError;
    };

    const handleChange = (e) => {
        const {name, value} = e.target;

        if (name === "customer_plan_total_value") return;

        setFormValues((prev) => {
            let newValues = {...prev, [name]: value};

            if (name === "plan") {
                const selectedPlan = plans.find((p) => p.id === Number(value));
                if (selectedPlan) {
                    newValues.customer_plan_value = parseFloat(selectedPlan.price) || 0;
                    const discount = parseFloat(newValues.customer_plan_discount) || 0;
                    const total = newValues.customer_plan_value - (newValues.customer_plan_value * discount / 100);
                    newValues.customer_plan_total_value = total > 0 ? total : "0.00";
                }
            }

            if (name === "customer_plan_value" || name === "customer_plan_discount") {
                const planValue = parseFloat(newValues.customer_plan_value) || 0;
                const discount = parseFloat(newValues.customer_plan_discount) || 0;
                const total = planValue - (planValue * discount / 100);
                newValues.customer_plan_total_value = total > 0 ? total : "0.00";
            }

            return newValues;
        });
    };

    const handleCancelRenewModal = (customer_id) => {
        openModal('CancelRenewModal', customer_id);
    };

    useEffect(() => {
        setLoading(true);

        const baseRequests = {
            plans: getPlans(),
            locations: getLocations(),
            services: getListServices(),
        };

        if (mode === "add" && data && Number.isInteger(Number(data))) {

            baseRequests.planDetail = getPlanDetail(data);
        }

        if (mode === "assign") {
            baseRequests.usersNoPlan = getUsersNoPlan();
        }

        Promise.all(Object.values(baseRequests))
            .then((results) => {
                const keys = Object.keys(baseRequests);
                const responsesMap = keys.reduce((acc, key, index) => {
                    acc[key] = results[index];
                    return acc;
                }, {});

                if (responsesMap.planDetail) {
                    // --- ADD ---
                    const d = responsesMap.planDetail;
                    setFormValues({
                        name: d?.name || "",
                        renewal_cycle_value: d?.renewal_cycle_value || "",
                        renewal_cycle_time: d?.renewal_cycle_time || "",
                        max_freeze_times: d?.max_freeze_times || "",
                        price: d?.price || "",
                        currency: d?.currency || "",
                        full_services_access: d?.full_services_access || false,
                        total_spots_per_service: d?.total_spots_per_service === -1 ? "" : d?.total_spots_per_service || "",
                        unlimited_spots: d?.total_spots_per_service === -1
                    });

                    setServices(mapPlanServices(d?.services || []));
                } else if (mode === "edit" && data?.memberships?.length) {
                    // --- EDIT ---
                    const mainMembership = data.memberships[0];
                    const extraServices = data.memberships.filter(m => m.extra_membership);

                    setFormValues({
                        plan: mainMembership.plan_id || "",
                        initial_plan: mainMembership.plan_id || "",
                        initial_extra_services: extraServices.map(s => {
                            const isUnlimited = Number(s?.remaining_quota) === -1;
                            return {
                                service: s.membership_service_id || "",
                                name: s.service_name || "",
                                accesses: isUnlimited ? "" : s?.remaining_quota || "",
                                unlimited: isUnlimited
                            };
                        }),
                        location: data.customer_location || "",
                        payment: data?.customer_payment_method || "",
                        customer_name: data.customer_name || "",
                        member_since: mainMembership?.membership_start_date || "",
                        freeze: Boolean(mainMembership.membership_freeze),
                        initial_freeze: Boolean(mainMembership.membership_freeze),
                        membership_freeze_start_date: mainMembership?.membership_freeze_start_date || "",
                        membership_freeze_end_date: mainMembership?.membership_freeze_end_date || "",
                        customer_payment_date: data?.customer_payment_date || "",
                        customer_plan_value: data?.customer_plan_value || "",
                        customer_plan_discount: data?.customer_plan_discount || "",
                        customer_plan_total_value: data?.customer_plan_total_value || "",
                        other_payment: data?.customer_other_payment_method || "",
                        pending_freeze: mainMembership?.pending_freeze || "",
                        date: mainMembership?.flag === 30 ? new Date().toISOString().split("T")[0] : null,
                    });

                    setServices(
                        extraServices.map(s => {
                            const isUnlimited = Number(s?.remaining_quota) === -1;
                            return {
                                service: s.membership_service_id || "",
                                name: s.service_name || "",
                                accesses: isUnlimited ? "" : s?.remaining_quota || "",
                                unlimited: isUnlimited
                            };
                        })
                    );
                } else if (mode === "renew" && data?.memberships?.length) {
                    // --- RENEW ---
                    const mainMembership = data.memberships[0];

                    setFormValues({
                        plan: mainMembership.plan_id || "",
                        location: data?.customer_location || "",
                        payment: data?.customer_payment_method || "",
                        customer_name: data.customer_name || "",
                        expiration_date: mainMembership?.membership_end_date || "",
                        customer_payment_date: data?.customer_payment_date || "",
                        customer_plan_value: data?.customer_plan_value || "",
                        customer_plan_discount: data?.customer_plan_discount || "",
                        customer_plan_total_value: data?.customer_plan_total_value || "",
                        other_payment: data?.customer_other_payment_method || "",
                        carry_over: false,
                        new_plan_start_date: new Date().toISOString().split("T")[0],
                        old_services: [],
                        pending_renew: mainMembership?.pending_renew || ""
                    });

                    setServices([]);
                } else if (mode === "assign") {
                    const users = responsesMap.usersNoPlan || [];
                    setUsersNoPlan(users);

                    setFormValues({
                        customer: data && Number.isInteger(Number(data)) ? Number(data) : "",
                        start_date: new Date().toISOString().split("T")[0],
                        location: "",
                        plan: "",
                        customer_payment_date: "",
                        customer_plan_value: "",
                        customer_plan_discount: "",
                        customer_plan_total_value: "",
                        payment: "",
                        other_payment: ""
                    });
                } else {
                    setServices([]);
                }
            })
            .finally(() => setLoading(false));
    }, [mode, data]);

    useEffect(() => {
        if (mode !== "add") return;
        if (planDetail?.services && listServices?.results) {
            const mapped = planDetail.services.map(item => {
                const found = listServices.results.find(s => s.id === item.service_id);
                const isUnlimited = item.quota === -1;
                return {
                    service: found?.id || item.service_id,
                    name: found?.name || item.service_name || "",
                    accesses: isUnlimited ? "" : item.quota,
                    unlimited: isUnlimited
                };
            });
            setServices(mapped);
        }
    }, [mode, planDetail, listServices]);

    return (
        <>
            <Modal show={show} onHide={onClose} centered size="sm" className="plan-form-modal" scrollable>
                <Modal.Header className="position-relative text-center justify-content-center">
                    <span className="plan-form-modal-title">
                        {titleAction} <strong>{titleSubject}</strong>
                    </span>
                    <div className="position-absolute end-0 top-50 translate-middle-y me-3">
                        <svg
                            type="button"
                            className="btn-close plan-form-modal-close"
                            aria-label="Close"
                            onClick={onClose}
                            xmlns="http://www.w3.org/2000/svg"
                            width="26"
                            height="27"
                            viewBox="0 0 26 27"
                            fill="none"
                        >
                            <path
                                d="M13 1.5C19.2984 1.5 24.5 6.81872 24.5 13.5C24.5 20.1813 19.2984 25.5 13 25.5C6.70158 25.5 1.5 20.1813 1.5 13.5C1.5 6.81872 6.70158 1.5 13 1.5Z"
                                stroke="#9DACBD"
                                strokeWidth="3"
                            />
                            <path d="M8 8.5L17.5 18" stroke="#9DACBD" strokeWidth="2" strokeLinecap="round"/>
                            <path d="M17.5 8.5L8 18" stroke="#9DACBD" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </div>
                </Modal.Header>

                <Modal.Body className="d-flex flex-column gap-3 px-4">
                    {/* ---------------- MODO RENEW ---------------- */}
                    {mode === "renew" && (
                        <>
                            <div>
                                <label className="form-label plan-form-modal-label mb-1">Locación</label>
                                <select
                                    className={`form-select plan-form-modal-select ${loading ? 'placeholder' : ''}`}
                                    name="location"
                                    value={formValues.location}
                                    onChange={handleChange}
                                >
                                    <option selected value="-1">Selecciona la sede</option>
                                    {locations?.map((location) => (
                                        <option key={location.id} value={location.id}>
                                            {location.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <select
                                    className={`form-select plan-form-modal-select ${loading ? 'placeholder' : ''}`}
                                    name="plan"
                                    value={formValues.plan}
                                    onChange={handleChange}
                                >
                                    <option selected>Plan</option>
                                    {plans?.map((plan) => (
                                        <option key={plan.id} value={plan.id}>
                                            {plan.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="d-flex flex-column gap-1">
                                <span
                                    className={`plan-form-modal-label ${loading ? 'placeholder placeholder-glow w-50' : ''}`}>
                                        {formValues.customer_name}
                                </span>
                                <span
                                    className={`plan-form-modal-label ${loading ? 'placeholder placeholder-glow w-50' : ''}`}>
                                    {formValues.expiration_date ? "Fecha de vencimiento: " + new Date(formValues.expiration_date).toLocaleDateString('es-CO') : ''}
                                </span>

                                {formValues.pending_renew && (() => {
                                    const [day, month, year] = formValues.pending_renew.split("-");
                                    const date = new Date(Number(year), Number(month) - 1, Number(day));
                                    if (isNaN(date.getTime())) return null;

                                    return (
                                        <span
                                            className={`plan-form-modal-label d-flex gap-2 align-items-center ${
                                                loading ? "placeholder placeholder-glow w-50" : ""
                                            }`}
                                        >
                                            <div className="plan-form-modal-label">
                                                <strong>Pendiente de renovación: </strong>
                                                {date.toLocaleDateString("es-CO")}
                                            </div>

                                            <Tooltip title={"Cancelar renovación"}>
                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    onClick={() => handleCancelRenewModal(data?.customer_id)}>
                                                        <i className="bi bi-trash-fill plan-form-modal-trash-icon"></i>
                                                </button>
                                            </Tooltip>

                                        </span>
                                    );
                                })()}
                            </div>

                            <div className="plan-form-modal-line"></div>

                            <div>
                                <label className="form-label plan-form-modal-label mb-1">Fecha de pago</label>
                                <input
                                    type="date"
                                    className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                    name="customer_payment_date"
                                    value={formValues.customer_payment_date || ""}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="d-flex flex-row justify-content-center align-items-center gap-1">
                                <div className="w-50">
                                    <label className="form-label plan-form-modal-label mb-1">Valor del Plan</label>
                                    <input
                                        type="number"
                                        className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                        name="customer_plan_value"
                                        value={formValues.customer_plan_value || ""}
                                        placeholder="automático"
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="w-50">
                                    <label className="form-label pre-register-user-label mb-0">
                                        % de DSCTO.
                                        <Popover
                                            title="Descuento"
                                            description="Ingresa el porcentaje de descuento que deseas aplicar, si lo requieres. Este es un campo opcional. El valor se calcula automáticamente sobre el total y se actualiza en el resumen de pago."
                                        >
                                            <svg className="ms-1" width="17" height="17" viewBox="0 0 17 17" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="8.5" cy="8.5" r="8.5" fill="#3177BE"/>
                                                <path
                                                    d="M8.68771 4.28522C9.89233 4.28522 11.0243 4.75355 11.8758 5.60505C12.7273 6.45655 13.1957 7.58855 13.1957 8.79317C13.1957 9.9978 12.7273 11.1298 11.8758 11.9813C11.0243 12.8328 9.89233 13.3011 8.68771 13.3011C7.48308 13.3011 6.35108 12.8328 5.49958 11.9813C4.64808 11.1298 4.17975 9.9978 4.17975 8.79317C4.17975 7.58855 4.64808 6.45655 5.49958 5.60505C6.35108 4.75355 7.48308 4.28522 8.68771 4.28522ZM8.68771 3.58398C5.81013 3.58398 3.47852 5.9156 3.47852 8.79317C3.47852 11.6707 5.81013 14.0024 8.68771 14.0024C11.5653 14.0024 13.8969 11.6707 13.8969 8.79317C13.8969 5.9156 11.5653 3.58398 8.68771 3.58398Z"
                                                    fill="white"/>
                                                <path
                                                    d="M8.52797 5.64C8.90664 5.64 9.24264 5.696 9.53597 5.808C9.8293 5.92 10.0586 6.08533 10.224 6.304C10.3893 6.51733 10.472 6.78133 10.472 7.096C10.472 7.416 10.4026 7.68 10.264 7.888C10.1306 8.09067 9.9493 8.24533 9.71997 8.352C9.49064 8.45333 9.2373 8.52 8.95997 8.552L8.90397 9.304H7.90397L7.91197 8.096C8.2693 8.05333 8.54664 7.99733 8.74397 7.928C8.94664 7.85333 9.08797 7.76 9.16797 7.648C9.2533 7.536 9.29597 7.40267 9.29597 7.248C9.29597 7.09867 9.26397 6.97333 9.19997 6.872C9.1413 6.77067 9.05064 6.69333 8.92797 6.64C8.8053 6.58667 8.64797 6.56 8.45597 6.56C8.17864 6.56 7.9573 6.64 7.79197 6.8C7.62664 6.95467 7.5253 7.176 7.48797 7.464L6.44797 7.064C6.51197 6.78667 6.6293 6.54133 6.79997 6.328C6.97064 6.10933 7.1973 5.94133 7.47997 5.824C7.76797 5.70133 8.1173 5.64 8.52797 5.64ZM8.41597 9.84C8.62397 9.84 8.7893 9.896 8.91197 10.008C9.03464 10.12 9.09597 10.2693 9.09597 10.456C9.09597 10.648 9.03464 10.8 8.91197 10.912C8.7893 11.0187 8.62397 11.072 8.41597 11.072C8.20797 11.072 8.04264 11.0187 7.91997 10.912C7.7973 10.8 7.73597 10.648 7.73597 10.456C7.73597 10.2693 7.7973 10.12 7.91997 10.008C8.04264 9.896 8.20797 9.84 8.41597 9.84Z"
                                                    fill="white"/>
                                            </svg>
                                        </Popover>
                                    </label>
                                    <input
                                        type="number"
                                        className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                        name="customer_plan_discount"
                                        value={formValues.customer_plan_discount || ""}
                                        placeholder="Escribe aquí"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="form-label plan-form-modal-label mb-1">Total</label>
                                <input
                                    type="text"
                                    className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                    name="customer_plan_total_value"
                                    value={formValues.customer_plan_total_value || ""}
                                    placeholder="automático"
                                    onChange={handleChange}
                                />
                            </div>

                            <div>
                                <label className="form-label plan-form-modal-label mb-1">Método de pago</label>
                                <select
                                    className={`form-select plan-form-modal-select ${loading ? 'placeholder' : ''}`}
                                    name="payment"
                                    value={formValues.payment}
                                    onChange={handleChange}
                                >
                                    <option selected>
                                        Selecciona un método de pago
                                    </option>
                                    {[
                                        {id: 10, name: "Tarjeta de Crédito o Débito"},
                                        {id: 20, name: "Transferencia"},
                                        {id: 30, name: "Efectivo"},
                                        {id: 40, name: "No registra"},
                                        {id: 50, name: "Otros"}
                                    ].map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {Number(formValues.payment) === 50 && (
                                <div>
                                    <label className="form-label plan-form-modal-label mb-1">Otro método de pago</label>
                                    <input
                                        type="text"
                                        className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                        placeholder="Escribe aquí"
                                        name="other_payment"
                                        value={formValues?.other_payment || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            )}

                            <div className="plan-form-modal-line"></div>

                            <div>
                                <div className="form-check">
                                    <input
                                        className={`form-check-input ${loading ? 'placeholder' : ''}`}
                                        type="checkbox"
                                        name="carry_over"
                                        checked={formValues.carry_over || false}
                                        onChange={(e) =>
                                            setFormValues((prev) => ({
                                                ...prev,
                                                carry_over: e.target.checked,
                                            }))
                                        }
                                    />
                                    <label className="form-check-label plan-form-modal-label">
                                        <strong>Sumar accesos pasados</strong>
                                    </label>
                                </div>
                                <div className="plan-form-modal-label">
                                    * Seleccionando esta opción se sumarán accesos sin usar del periodo vencido.
                                </div>
                            </div>

                            <div>
                                {services?.length > 0 && services.map((service) => (
                                    <div className="form-check" key={service.id}>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="serviceRadio"
                                            id={`service-${service.id}`}
                                            value={service.id}
                                            checked={formValues?.service_id === service.id}
                                            onChange={(e) =>
                                                setFormValues((prev) => ({
                                                    ...prev,
                                                    service_id: Number(e.target.value),
                                                }))
                                            }
                                        />
                                        <label className="form-check-label" htmlFor={`service-${service.id}`}>
                                            {service.name}
                                        </label>
                                    </div>
                                ))}
                            </div>

                            {formValues.carry_over && data?.memberships?.length > 0 && (
                                <div>
                                    <label className="form-label plan-form-modal-label">
                                        Selecciona los servicios a sumar:
                                    </label>
                                    <div className="d-flex flex-column gap-1">
                                        {data.memberships.map((m) => {
                                            const isUnlimited = m.remaining_quota === -1;
                                            const serviceId = m.membership_service_id === "FullAccess"
                                                ? -1
                                                : Number(m.membership_service_id);
                                            const isChecked = formValues.old_services?.includes(serviceId);

                                            return (
                                                <div className="form-check" key={serviceId}>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`service-${serviceId}`}
                                                        value={serviceId}
                                                        checked={isChecked}
                                                        disabled={isUnlimited}
                                                        onChange={(e) => {
                                                            let updated = formValues.old_services || [];
                                                            const val = Number(e.target.value);
                                                            if (e.target.checked) {
                                                                updated = [...updated, val];
                                                            } else {
                                                                updated = updated.filter((id) => id !== val);
                                                            }
                                                            setFormValues({
                                                                ...formValues,
                                                                old_services: updated,
                                                            });
                                                        }}
                                                    />
                                                    <label
                                                        className="form-check-label plan-form-modal-label"
                                                        htmlFor={`service-${serviceId}`}
                                                    >
                                                        {m.service_name}{" "}
                                                        <small className="text-muted">
                                                            ({isUnlimited ? "Ilimitado" : `${m.remaining_quota} accesos`})
                                                        </small>
                                                    </label>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}

                            <div className="plan-form-modal-line"></div>

                            <div>
                                <label className="form-label plan-form-modal-label mb-1">
                                    Fecha de inicio del nuevo plan
                                </label>
                                <input
                                    type="date"
                                    className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                    name="new_plan_start_date"
                                    value={formValues.new_plan_start_date || ""}
                                    onChange={handleChange}
                                />
                                <div className="form-text plan-form-modal-label">
                                    Si el anterior sigue activo, esta fecha definirá cuándo inicia el nuevo ciclo.
                                </div>
                            </div>

                            <button
                                className="button w-50 align-self-center plan-form-modal-button"
                                onClick={handleRenewMembership}
                                disabled={sending}
                            >
                                {sending ? (
                                    <span className="spinner-border spinner-border-sm " role="status"
                                          aria-hidden="true"></span>
                                ) : (<>
                                    Renovar plan
                                </>)}
                            </button>
                        </>
                    )}

                    {/* ---------------- MODO EDIT ---------------- */}
                    {mode === "edit" && (
                        <>
                            <div>
                                <label className="form-label plan-form-modal-label mb-1">Locación</label>
                                <select
                                    className={`form-select plan-form-modal-select ${loading ? 'placeholder' : ''}`}
                                    name="location"
                                    value={formValues.location}
                                    onChange={handleChange}
                                >
                                    <option selected value="-1">Selecciona la sede</option>
                                    {locations?.map((location) => (
                                        <option key={location.id} value={location.id}>
                                            {location.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <select
                                    className={`form-select plan-form-modal-select ${loading ? 'placeholder' : ''}`}
                                    name="plan"
                                    value={formValues.plan}
                                    onChange={handleChange}
                                >
                                    <option selected>Plan</option>
                                    {plans?.map((plan) => (
                                        <option key={plan.id} value={plan.id}>
                                            {plan.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="d-flex flex-column gap-1">
                                <span
                                    className={`plan-form-modal-label ${loading ? 'placeholder placeholder-glow w-50' : ''}`}>
                                        {formValues.customer_name}
                                </span>
                                <span
                                    className={`plan-form-modal-label ${loading ? 'placeholder placeholder-glow w-50' : ''}`}>
                                    {formValues.member_since ? "Miembro desde: " + new Date(formValues.member_since).toLocaleDateString('es-CO') : ''}
                                </span>

                                {formValues.pending_freeze && (() => {
                                    const fecha = new Date(formValues.membership_freeze_start_date);
                                    if (isNaN(fecha.getTime())) return null;

                                    return (
                                        <span
                                            className={`plan-form-modal-label d-flex gap-2 align-items-center ${
                                                loading ? "placeholder placeholder-glow w-50" : ""
                                            }`}
                                        >
                                            <div className="plan-form-modal-label">
                                                <strong>Pendiente de congelación: </strong>
                                                {fecha.toLocaleDateString("es-CO")}
                                                <i className="bi bi-snow ms-1"></i>
                                            </div>
                                        </span>
                                    );
                                })()}

                            </div>

                            <div className="plan-form-modal-line"></div>

                            <div>
                                <label className="form-label plan-form-modal-label mb-1">Fecha de pago</label>
                                <input
                                    type="date"
                                    className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                    name="customer_payment_date"
                                    value={formValues.customer_payment_date || ""}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="d-flex flex-row justify-content-center align-items-center gap-1">
                                <div className="w-50">
                                    <label className="form-label plan-form-modal-label mb-1">Valor del Plan</label>
                                    <input
                                        type="text"
                                        className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                        name="customer_plan_value"
                                        value={formValues.customer_plan_value || ""}
                                        placeholder="automático"
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="w-50">
                                    <label className="form-label pre-register-user-label mb-0">
                                        % de DSCTO.
                                        <Popover
                                            title="Descuento"
                                            description="Ingresa el porcentaje de descuento que deseas aplicar, si lo requieres. Este es un campo opcional. El valor se calcula automáticamente sobre el total y se actualiza en el resumen de pago."
                                        >
                                            <svg className="ms-1" width="17" height="17" viewBox="0 0 17 17" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="8.5" cy="8.5" r="8.5" fill="#3177BE"/>
                                                <path
                                                    d="M8.68771 4.28522C9.89233 4.28522 11.0243 4.75355 11.8758 5.60505C12.7273 6.45655 13.1957 7.58855 13.1957 8.79317C13.1957 9.9978 12.7273 11.1298 11.8758 11.9813C11.0243 12.8328 9.89233 13.3011 8.68771 13.3011C7.48308 13.3011 6.35108 12.8328 5.49958 11.9813C4.64808 11.1298 4.17975 9.9978 4.17975 8.79317C4.17975 7.58855 4.64808 6.45655 5.49958 5.60505C6.35108 4.75355 7.48308 4.28522 8.68771 4.28522ZM8.68771 3.58398C5.81013 3.58398 3.47852 5.9156 3.47852 8.79317C3.47852 11.6707 5.81013 14.0024 8.68771 14.0024C11.5653 14.0024 13.8969 11.6707 13.8969 8.79317C13.8969 5.9156 11.5653 3.58398 8.68771 3.58398Z"
                                                    fill="white"/>
                                                <path
                                                    d="M8.52797 5.64C8.90664 5.64 9.24264 5.696 9.53597 5.808C9.8293 5.92 10.0586 6.08533 10.224 6.304C10.3893 6.51733 10.472 6.78133 10.472 7.096C10.472 7.416 10.4026 7.68 10.264 7.888C10.1306 8.09067 9.9493 8.24533 9.71997 8.352C9.49064 8.45333 9.2373 8.52 8.95997 8.552L8.90397 9.304H7.90397L7.91197 8.096C8.2693 8.05333 8.54664 7.99733 8.74397 7.928C8.94664 7.85333 9.08797 7.76 9.16797 7.648C9.2533 7.536 9.29597 7.40267 9.29597 7.248C9.29597 7.09867 9.26397 6.97333 9.19997 6.872C9.1413 6.77067 9.05064 6.69333 8.92797 6.64C8.8053 6.58667 8.64797 6.56 8.45597 6.56C8.17864 6.56 7.9573 6.64 7.79197 6.8C7.62664 6.95467 7.5253 7.176 7.48797 7.464L6.44797 7.064C6.51197 6.78667 6.6293 6.54133 6.79997 6.328C6.97064 6.10933 7.1973 5.94133 7.47997 5.824C7.76797 5.70133 8.1173 5.64 8.52797 5.64ZM8.41597 9.84C8.62397 9.84 8.7893 9.896 8.91197 10.008C9.03464 10.12 9.09597 10.2693 9.09597 10.456C9.09597 10.648 9.03464 10.8 8.91197 10.912C8.7893 11.0187 8.62397 11.072 8.41597 11.072C8.20797 11.072 8.04264 11.0187 7.91997 10.912C7.7973 10.8 7.73597 10.648 7.73597 10.456C7.73597 10.2693 7.7973 10.12 7.91997 10.008C8.04264 9.896 8.20797 9.84 8.41597 9.84Z"
                                                    fill="white"/>
                                            </svg>
                                        </Popover>
                                    </label>
                                    <input
                                        type="text"
                                        className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                        name="customer_plan_discount"
                                        value={formValues.customer_plan_discount || ""}
                                        placeholder="Escribe aquí"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="form-label plan-form-modal-label mb-1">Total</label>
                                <input
                                    type="text"
                                    className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                    name="customer_plan_total_value"
                                    value={formValues.customer_plan_total_value || ""}
                                    placeholder="automático"
                                    onChange={handleChange}
                                    readOnly
                                />
                            </div>

                            <div>
                                <label className="form-label plan-form-modal-label mb-1">Método de pago</label>
                                <select
                                    className={`form-select plan-form-modal-select ${loading ? 'placeholder' : ''}`}
                                    name="payment"
                                    value={formValues.payment}
                                    onChange={handleChange}
                                >
                                    <option selected>
                                        Selecciona un método de pago
                                    </option>
                                    {[
                                        {id: 10, name: "Tarjeta de Crédito o Débito"},
                                        {id: 20, name: "Transferencia"},
                                        {id: 30, name: "Efectivo"},
                                        {id: 40, name: "No registra"},
                                        {id: 50, name: "Otros"}
                                    ].map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {Number(formValues.payment) === 50 && (
                                <div>
                                    <label className="form-label plan-form-modal-label mb-1">Otro método de pago</label>
                                    <input
                                        type="text"
                                        className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                        placeholder="Escribe aquí"
                                        name="other_payment"
                                        value={formValues?.other_payment || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            )}

                            {formValues.date ? (
                                <>
                                    <div className="plan-form-modal-line"></div>
                                    <div>
                                        <label className="form-label plan-form-modal-label mb-1">
                                            Fecha de inicio del nuevo plan
                                        </label>
                                        <input
                                            type="date"
                                            className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                            name="date"
                                            value={formValues.date || ""}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="plan-form-modal-line"></div>

                                    <div>
                                        <div className="form-check">
                                            <input
                                                className={`form-check-input ${loading ? 'placeholder' : ''}`}
                                                type="checkbox"
                                                checked={!!formValues.freeze}
                                                onChange={(e) =>
                                                    setFormValues(prev => ({
                                                        ...prev,
                                                        freeze: e.target.checked
                                                    }))
                                                }
                                            />
                                            <label className="form-check-label plan-form-modal-label">
                                                Congelar membresía <i className="bi bi-snow"></i>
                                            </label>
                                        </div>

                                        {formValues.freeze && (
                                            <div className="d-flex gap-2">
                                                <div className="w-50">
                                                    <label className="form-label plan-form-modal-label mb-1">
                                                        Fecha inicio
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                                        name="membership_freeze_start_date"
                                                        value={formValues.membership_freeze_start_date || ""}
                                                        onChange={handleChange}
                                                    />
                                                </div>

                                                <div className="w-50">
                                                    <label className="form-label plan-form-modal-label mb-1">
                                                        Fecha fin
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                                        name="membership_freeze_end_date"
                                                        value={formValues.membership_freeze_end_date || ""}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="text-center">
                                        <label className="plan-form-modal-label mb-1">Agregar servicios extra</label>
                                        <div className="d-flex gap-2 justify-content-center align-items-center">
                                            <button
                                                className="button plan-form-modal-button-circle rounded-circle"
                                                onClick={addService}
                                            >
                                                +
                                            </button>
                                            <label className="plan-form-modal-label cursor-pointer"
                                                   onClick={addService}>
                                                Agregar servicio
                                            </label>
                                        </div>
                                    </div>

                                    {services?.map((item, index) => (
                                        <div key={index} className="mb-2">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <label className="plan-form-modal-label">Servicio {index + 1}</label>
                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    onClick={() => removeService(index)}
                                                >
                                                    <i className="bi bi-trash-fill plan-form-modal-trash-icon"></i>
                                                </button>
                                            </div>
                                            <select
                                                className="form-select plan-form-modal-select mb-2"
                                                value={item.service}
                                                onChange={(e) => updateService(index, "service", e.target.value)}
                                            >
                                                <option value="">Seleccionar servicio</option>
                                                {listServices?.results?.map((service) => (
                                                    <option key={service.id} value={service.id}>
                                                        {service.name}
                                                    </option>
                                                ))}
                                            </select>
                                            <input
                                                type="text"
                                                className="plan-form-modal-input"
                                                placeholder="Accesos"
                                                value={item.accesses}
                                                onChange={(e) => updateService(index, "accesses", e.target.value)}
                                            />
                                        </div>
                                    ))}
                                </>
                            )}

                            <button
                                className="button w-50 align-self-center plan-form-modal-button"
                                onClick={handleEditMembership}
                                disabled={sending}
                            >
                                {sending ? (
                                    <span className="spinner-border spinner-border-sm " role="status"
                                          aria-hidden="true"></span>
                                ) : (<>
                                    Confirmar
                                </>)}
                            </button>
                        </>
                    )}

                    {/* ---------------- MODO ASSIGN ---------------- */}
                    {mode === "assign" && (
                        <>
                            <div>
                                <label className="form-label plan-form-modal-label mb-1">Locación</label>
                                <select
                                    className={`form-select plan-form-modal-select ${loading ? 'placeholder' : ''}`}
                                    name="location"
                                    value={formValues.location}
                                    onChange={handleChange}
                                >
                                    <option selected value="-1">Selecciona la sede</option>
                                    {locations?.map((location) => (
                                        <option key={location.id} value={location.id}>
                                            {location.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <select
                                    className={`form-select plan-form-modal-select ${loading ? "placeholder" : ""}`}
                                    name="customer"
                                    value={formValues.customer || ""}
                                    onChange={handleChange}
                                >
                                    <option value="">Usuarios sin plan</option>
                                    {usersNoPlan?.map((user) => (
                                        <option key={user.id} value={user.id}>
                                            {user.name} ({user.email})
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <select
                                    className={`form-select plan-form-modal-select ${loading ? "placeholder" : ""}`}
                                    name="plan"
                                    value={formValues.plan || ""}
                                    onChange={handleChange}
                                >
                                    <option value="">Selecciona un plan</option>
                                    {plans?.map((plan) => (
                                        <option key={plan.id} value={plan.id}>
                                            {plan.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <input
                                    type="date"
                                    className={`plan-form-modal-input ${loading ? "placeholder" : ""}`}
                                    name="start_date"
                                    value={formValues.start_date || ""}
                                    onChange={handleChange}
                                />
                            </div>


                            <div className="plan-form-modal-line"></div>

                            <div>
                                <label className="form-label plan-form-modal-label mb-1">Fecha de pago</label>
                                <input
                                    type="date"
                                    className={`plan-form-modal-input ${loading ? "placeholder" : ""}`}
                                    name="customer_payment_date"
                                    value={formValues.customer_payment_date || ""}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="d-flex flex-row justify-content-center align-items-center gap-1">
                                <div className="w-50">
                                    <label className="form-label plan-form-modal-label mb-1">Valor del Plan</label>
                                    <input
                                        type="text"
                                        className={`plan-form-modal-input ${loading ? "placeholder" : ""}`}
                                        name="customer_plan_value"
                                        value={formValues.customer_plan_value || ""}
                                        placeholder="automático"
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="w-50">
                                    <label className="form-label pre-register-user-label mb-0">
                                        % de DSCTO.
                                        <Popover
                                            title="Descuento"
                                            description="Ingresa el porcentaje de descuento que deseas aplicar, si lo requieres. Este es un campo opcional. El valor se calcula automáticamente sobre el total y se actualiza en el resumen de pago."
                                        >
                                            <svg className="ms-1" width="17" height="17" viewBox="0 0 17 17" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="8.5" cy="8.5" r="8.5" fill="#3177BE"/>
                                                <path
                                                    d="M8.68771 4.28522C9.89233 4.28522 11.0243 4.75355 11.8758 5.60505C12.7273 6.45655 13.1957 7.58855 13.1957 8.79317C13.1957 9.9978 12.7273 11.1298 11.8758 11.9813C11.0243 12.8328 9.89233 13.3011 8.68771 13.3011C7.48308 13.3011 6.35108 12.8328 5.49958 11.9813C4.64808 11.1298 4.17975 9.9978 4.17975 8.79317C4.17975 7.58855 4.64808 6.45655 5.49958 5.60505C6.35108 4.75355 7.48308 4.28522 8.68771 4.28522ZM8.68771 3.58398C5.81013 3.58398 3.47852 5.9156 3.47852 8.79317C3.47852 11.6707 5.81013 14.0024 8.68771 14.0024C11.5653 14.0024 13.8969 11.6707 13.8969 8.79317C13.8969 5.9156 11.5653 3.58398 8.68771 3.58398Z"
                                                    fill="white"/>
                                                <path
                                                    d="M8.52797 5.64C8.90664 5.64 9.24264 5.696 9.53597 5.808C9.8293 5.92 10.0586 6.08533 10.224 6.304C10.3893 6.51733 10.472 6.78133 10.472 7.096C10.472 7.416 10.4026 7.68 10.264 7.888C10.1306 8.09067 9.9493 8.24533 9.71997 8.352C9.49064 8.45333 9.2373 8.52 8.95997 8.552L8.90397 9.304H7.90397L7.91197 8.096C8.2693 8.05333 8.54664 7.99733 8.74397 7.928C8.94664 7.85333 9.08797 7.76 9.16797 7.648C9.2533 7.536 9.29597 7.40267 9.29597 7.248C9.29597 7.09867 9.26397 6.97333 9.19997 6.872C9.1413 6.77067 9.05064 6.69333 8.92797 6.64C8.8053 6.58667 8.64797 6.56 8.45597 6.56C8.17864 6.56 7.9573 6.64 7.79197 6.8C7.62664 6.95467 7.5253 7.176 7.48797 7.464L6.44797 7.064C6.51197 6.78667 6.6293 6.54133 6.79997 6.328C6.97064 6.10933 7.1973 5.94133 7.47997 5.824C7.76797 5.70133 8.1173 5.64 8.52797 5.64ZM8.41597 9.84C8.62397 9.84 8.7893 9.896 8.91197 10.008C9.03464 10.12 9.09597 10.2693 9.09597 10.456C9.09597 10.648 9.03464 10.8 8.91197 10.912C8.7893 11.0187 8.62397 11.072 8.41597 11.072C8.20797 11.072 8.04264 11.0187 7.91997 10.912C7.7973 10.8 7.73597 10.648 7.73597 10.456C7.73597 10.2693 7.7973 10.12 7.91997 10.008C8.04264 9.896 8.20797 9.84 8.41597 9.84Z"
                                                    fill="white"/>
                                            </svg>
                                        </Popover>
                                    </label>
                                    <input
                                        type="text"
                                        className={`plan-form-modal-input ${loading ? "placeholder" : ""}`}
                                        name="customer_plan_discount"
                                        value={formValues.customer_plan_discount || ""}
                                        placeholder="Escribe aquí"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="form-label plan-form-modal-label mb-1">Total</label>
                                <input
                                    type="text"
                                    className={`plan-form-modal-input ${loading ? "placeholder" : ""}`}
                                    name="customer_plan_total_value"
                                    value={formValues.customer_plan_total_value || ""}
                                    placeholder="automático"
                                    onChange={handleChange}
                                    readOnly={true}
                                />
                            </div>

                            <div>
                                <label className="form-label plan-form-modal-label mb-1">Método de pago</label>
                                <select
                                    className={`form-select plan-form-modal-select ${loading ? "placeholder" : ""}`}
                                    name="payment"
                                    value={formValues.payment || ""}
                                    onChange={handleChange}
                                >
                                    <option value="">Selecciona un método de pago</option>
                                    {[
                                        {id: 10, name: "Tarjeta de Crédito o Débito"},
                                        {id: 20, name: "Transferencia"},
                                        {id: 30, name: "Efectivo"},
                                        {id: 40, name: "No registra"},
                                        {id: 50, name: "Otros"}
                                    ].map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {Number(formValues.payment) === 50 && (
                                <div>
                                    <label className="form-label plan-form-modal-label mb-1">Otro método de pago</label>
                                    <input
                                        type="text"
                                        className={`plan-form-modal-input ${loading ? "placeholder" : ""}`}
                                        placeholder="Escribe aquí"
                                        name="other_payment"
                                        value={formValues?.other_payment || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            )}

                            <div className="plan-form-modal-line"></div>

                            <button
                                className="button w-50 align-self-center plan-form-modal-button"
                                onClick={handleAssignMembership}
                                disabled={sending}
                            >
                                {sending ? (
                                    <span className="spinner-border spinner-border-sm " role="status"
                                          aria-hidden="true"></span>
                                ) : (
                                    <>Confirmar</>
                                )}
                            </button>
                        </>
                    )}

                    {/* ---------------- MODO ADD ---------------- */}
                    {mode === "add" && (
                        <>
                            <div>
                                <input
                                    type="text"
                                    className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                    placeholder="Nombre"
                                    name="name"
                                    value={formValues.name || ""}
                                    onChange={handleChange}
                                />
                            </div>

                            <div>
                                <select
                                    className={`form-select plan-form-modal-select ${loading ? 'placeholder' : ''}`}
                                    name="renewal_cycle_time"
                                    value={formValues.renewal_cycle_time || ""}
                                    onChange={handleChange}
                                >
                                    <option value="">Ciclo de renovación</option>
                                    {[
                                        {id: 1, name: "Diario", value: 10},
                                        {id: 2, name: "Mensual", value: 20},
                                        {id: 3, name: "Anual", value: 30},
                                    ].map((item) => (
                                        <option key={item.id} value={item.value}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <input
                                    type="number"
                                    className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                    placeholder="Frecuencia de renovación"
                                    name="renewal_cycle_value"
                                    value={formValues.renewal_cycle_value || ""}
                                    onChange={handleChange}
                                />
                            </div>

                            <div>
                                <input
                                    type="number"
                                    className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                    placeholder="Número de congelaciones"
                                    name="max_freeze_times"
                                    value={formValues.max_freeze_times || ""}
                                    onChange={handleChange}
                                />
                            </div>

                            <div>
                                <input
                                    type="number"
                                    className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                    placeholder="Costo"
                                    name="price"
                                    value={formValues.price || ""}
                                    onChange={handleChange}
                                />
                            </div>

                            <div>
                                <input
                                    type="text"
                                    className={`plan-form-modal-input ${loading ? 'placeholder' : ''}`}
                                    placeholder="Pesos Colombianos (Moneda)"
                                    name="currency"
                                    value={formValues.currency || ""}
                                    onChange={handleChange}
                                    readOnly
                                />
                            </div>

                            <div>
                                <div className="form-check">
                                    <input
                                        className={`form-check-input ${loading ? 'placeholder' : ''}`}
                                        type="checkbox"
                                        name="full_services_access"
                                        checked={formValues.full_services_access || false}
                                        onChange={(e) =>
                                            setFormValues((prev) => ({
                                                ...prev,
                                                full_services_access: e.target.checked,
                                                total_spots_per_service: e.target.checked ? prev.total_spots_per_service : "",
                                                unlimited_spots: e.target.checked ? prev.unlimited_spots : false,
                                            }))
                                        }
                                    />
                                    <label className="form-check-label plan-form-modal-label">
                                        <strong>Accesos libres</strong>
                                    </label>
                                </div>
                                <div className="plan-form-modal-label">
                                    *Seleccionado accesos libres, tu cliente podrá usar sus accesos libremente.
                                </div>
                            </div>

                            {formValues.full_services_access && (
                                <div>
                                    <input
                                        type="number"
                                        className={`plan-form-modal-input mb-2 ${loading ? 'placeholder' : ''}`}
                                        placeholder="Cantidad de accesos libres"
                                        value={formValues.unlimited_spots ? "" : formValues.total_spots_per_service || ""}
                                        onChange={(e) =>
                                            setFormValues((prev) => ({
                                                ...prev,
                                                total_spots_per_service: e.target.value,
                                            }))
                                        }
                                        disabled={formValues.unlimited_spots}
                                    />
                                    <div className="form-check">
                                        <input
                                            className={`form-check-input ${loading ? 'placeholder' : ''}`}
                                            type="checkbox"
                                            checked={!!formValues.unlimited_spots}
                                            onChange={(e) =>
                                                setFormValues((prev) => ({
                                                    ...prev,
                                                    unlimited_spots: e.target.checked,
                                                    total_spots_per_service: e.target.checked
                                                        ? -1
                                                        : ""
                                                }))
                                            }
                                        />
                                        <label className="form-check-label plan-form-modal-label">
                                            <strong>Ilimitados</strong>
                                        </label>
                                    </div>
                                </div>
                            )}

                            <div className="plan-form-modal-line"></div>

                            {!formValues.full_services_access && (
                                <>
                                    <div className="text-center">
                                        <div className="d-flex gap-2 justify-content-center align-items-center">
                                            <button
                                                className="button plan-form-modal-button-circle rounded-circle"
                                                onClick={addService}
                                            >
                                                +
                                            </button>
                                            <label className="plan-form-modal-label" onClick={addService}>
                                                Agregar servicio
                                            </label>
                                        </div>
                                    </div>

                                    {services?.map((item, index) => (
                                        <div key={index} className="mb-2">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <label className="plan-form-modal-label">Servicio {index + 1}</label>
                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    onClick={() => removeService(index)}
                                                >
                                                    <i className="bi bi-trash-fill plan-form-modal-trash-icon"></i>
                                                </button>
                                            </div>
                                            <select
                                                className="form-select plan-form-modal-select mb-2"
                                                value={item.service}
                                                onChange={(e) => updateService(index, "service", e.target.value)}
                                            >
                                                <option value="">Seleccionar servicio</option>
                                                {listServices?.results?.map((service) => (
                                                    <option key={service.id} value={service.id}>
                                                        {service.name}
                                                    </option>
                                                ))}
                                            </select>
                                            <input
                                                type="text"
                                                className="plan-form-modal-input mb-2"
                                                placeholder="Accesos"
                                                value={item.accesses}
                                                onChange={(e) => updateService(index, "accesses", e.target.value)}
                                                disabled={!!item.unlimited}
                                            />
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={!!item.unlimited}
                                                    onChange={(e) => updateService(index, "unlimited", e.target.checked)}
                                                />
                                                <label className="form-check-label plan-form-modal-label">
                                                    <strong>Ilimitados</strong>
                                                </label>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}

                            <button
                                className="button w-50 align-self-center plan-form-modal-button"
                                onClick={handleSavePlan}
                                disabled={sending}
                            >
                                {sending ? (
                                    <span className="spinner-border spinner-border-sm " role="status"
                                          aria-hidden="true"></span>
                                ) : (<>
                                    Guardar
                                </>)}
                            </button>
                        </>
                    )}
                </Modal.Body>
            </Modal>

            {activeModal === 'InfoModal' && (
                <InlineModal
                    show
                    title={typeof modalData === "string" ? modalData : modalData.title}
                    description={typeof modalData === "string" ? null : modalData.description}
                    primaryAction={
                        typeof modalData === "string"
                            ? {
                                label: "Confirmar", onClick: () => {
                                    closeModal();
                                    onClose();
                                }
                            }
                            : modalData.primaryAction
                    }
                />
            )}

            {activeModal === 'CancelRenewModal' && (
                <InlineModal
                    show
                    title={"¿Estás seguro de cancelar la renovación?"}
                    primaryAction={{
                        label: "Confirmar",
                        onClick: () => {
                            handleCancelRenew(modalData)
                        },
                    }}
                    secondaryAction={{
                        label: "Cancelar",
                        onClick: () => {
                            closeModal()
                        }
                    }}
                />
            )}

            <DisclaimerModal
                title={disclaimers[mode]?.title}
                description={disclaimers[mode]?.description}
                storageKey={disclaimers[mode]?.storageKey}
            />
        </>

    );
};

export default PlanFormModal;
